import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { QUOTE_QUESTIONS } from "../../AppConstants";

const rules = {
    education: 'required',
    employment: 'required',
    occupation: [
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.EMPLOYED,
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.SELF_EMPLOYED,
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.RETIRED,
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.UNEMPLOYED,
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.OTHER
    ],
    hasBAverageOrHigher: [
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_GRADUATE,
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_UNDERGRADUATE,
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_HIGH_SCHOOL,
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_TRADE_SCHOOL
    ],
    militaryBranch: [
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.MILITARY,
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.RETIRED_MILITARY
    ],
    militaryRank: [
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.MILITARY,
        'required_if:employment,' + QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.RETIRED_MILITARY
    ],
};

export const allFieldsValidation = (data, stateCode: string | null = null) => {
    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};